import React, { useState, useEffect } from "react";
import { setEditorSaved } from "../../../../../../../redux/actions/integrationActions";
import { useDispatch, useSelector } from "react-redux";
import Select from "@atlaskit/select";
import { Flex, Flex1 } from "../../../../../../../common/style";
import CellTextField from "../../../../../../../common/components/CellTextField";
import { ComparisonOperator } from "../../../../../../../common/interfaces/flow/condition/ComparisonOperator";
import { Label } from "@atlaskit/form";

const OPERATORS = [
  { label: "EQUALS", value: ComparisonOperator.EQUALS },
  { label: "NOT EQUALS", value: ComparisonOperator.NOT_EQUALS },
  { label: "GREATER THAN", value: ComparisonOperator.GREATER_THAN },
  { label: "GREATER THAN OR EQUAL TO", value: ComparisonOperator.GREATER_THAN_OR_EQUAL_TO },
  { label: "LESS THAN", value: ComparisonOperator.LESS_THAN },
  { label: "LESS THAN OR EQUAL TO", value: ComparisonOperator.LESS_THAN_OR_EQUAL_TO },
  { label: "INCLUDES", value: ComparisonOperator.INCLUDES },
  { label: "NOT INCLUDES", value: ComparisonOperator.NOT_INCLUDES },
  { label: "REGEXP", value: ComparisonOperator.REGEXP },
];
const DataConditionPanel = ({ dataCondition }) => {
  const [operator, setOperator] = useState(OPERATORS[0]);
  const [jsonPath, setJsonPath] = useState(OPERATORS[0]);
  const [value, setValue] = useState(OPERATORS[0]);
  const dispatch = useDispatch();
  const JSON_PATH = "JSONPATH";
  const VALUE = "VALUE";
  const saved = useSelector((state) => state.integration.saved);

  useEffect(() => {
    if (dataCondition && dataCondition.jsonPath != jsonPath) {
      setJsonPath(dataCondition.jsonPath);
    }
    if (dataCondition && dataCondition.value != value) {
      setValue(dataCondition.value);
    }
    if (dataCondition && dataCondition.operator != operator.value) {
      setOperator(OPERATORS.find((o) => o.value === dataCondition.operator));
    }
  }, [dataCondition]);

  const onChange = (cellChange, index, type) => {
    if (type === JSON_PATH) {
      dataCondition.jsonPath = cellChange;
    }
    if (type === VALUE) {
      dataCondition.value = cellChange;
    }
    if (saved) {
      dispatch(setEditorSaved(false));
    }
  };
  const onChangeOperator = (operatorOption) => {
    setOperator(operatorOption);
    dataCondition.operator = operatorOption.value;
    if (saved) {
      dispatch(setEditorSaved(false));
    }
  };

  return (
    <Flex>
      <Flex1>
        <Label>JSON Path</Label>
        <CellTextField inputValue={dataCondition.jsonPath} onChange={onChange} index={1} type={JSON_PATH} />
      </Flex1>
      <Flex1>
        <Label>Operand</Label>
        <Select
          options={OPERATORS}
          spacing="compact"
          name="selectOperand"
          className="ihub-action-cond-operand-select"
          value={operator}
          onChange={onChangeOperator}
        />
      </Flex1>
      <Flex1>
        <Label>Value</Label>
        <CellTextField inputValue={dataCondition.value} onChange={onChange} index={2} type={VALUE} />
      </Flex1>
    </Flex>
  );
};

export default DataConditionPanel;
